import classNames from "classnames";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import {
  selectSearch,
  selectSearchCalculatePrice,
  selectSearchFilter,
} from "../../../store/selectors";
import {
  sortName,
  sortDate,
  filterRangePrice,
  SORT_TYPE,
  sortPrice,
} from "../../../store/slices/searchFilterSlice";
import { useTypedDispatch, useTypedSelector } from "../../../store/store";
import { currencyToFormat } from "../../../utils/helpers/currency";
import Button from "../../shared/Button";
import RangeSlider from "../../shared/RangeSlider";

import styles from "./index.module.scss";

function SearchFilter() {
  const { t } = useTranslation();

  const [showFilter, setShowFilter] = React.useState(false);

  const handleShowFilter = () => {
    setShowFilter(!showFilter);
  };

  return (
    <div className={classNames(styles.container)}>
      <Button
        variant="dark"
        label={t("Filter results")}
        onClick={handleShowFilter}
      />
      {showFilter && <SearchFilterForm />}
    </div>
  );
}

function SearchFilterForm() {
  const { t } = useTranslation();

  const dispatch = useTypedDispatch();
  const filter = useTypedSelector(selectSearchFilter);
  const filterPrices = useTypedSelector(selectSearchCalculatePrice);

  const [rangePrice, setRangePrice] = React.useState([...filterPrices]);
  const { results: searchResults } = useTypedSelector(selectSearch);
  const currency =
    searchResults?.find((result) => result?.markets?.currency)?.markets
      ?.currency || "USD";

  const handleSortName = () => {
    dispatch(sortName(!filter.sortName));
  };

  const handleSortDate = () => {
    dispatch(sortDate(!filter.sortDate));
  };

  const handleSortPrice = () => {
    dispatch(sortPrice(!filter.sortPrice));
  };

  const handleRangePrice = (minPrice: number, maxPrice: number) => {
    dispatch(filterRangePrice([minPrice, maxPrice]));
  };

  useEffect(() => {
    handleRangePrice(filterPrices[0], filterPrices[1]);
  }, [filterPrices]);

  return (
    <div className={classNames(styles.content)}>
      <div className={classNames(styles.rangeSliderContainer)}>
        <p className={classNames(styles.labelRangePrice)}>
          {currencyToFormat(rangePrice[0], currency || "USD")} -{" "}
          {currencyToFormat(rangePrice[1], currency || "USD")}
        </p>

        <RangeSlider
          min={filterPrices[0]}
          max={filterPrices[1]}
          onMouseUp={(value) => handleRangePrice(value.min, value.max)}
          onChange={(value) => setRangePrice([value.min, value.max])}
        />
      </div>

      <Button
        className={classNames(
          {
            [styles.activeButton]: filter.sortType === SORT_TYPE.NAME,
          },
          styles.button,
        )}
        label={`${t("sort name")}: ${filter.sortName ? "A-Z" : "Z-A"}`}
        icon={filter.sortName ? "FiArrowDown" : "FiArrowUp"}
        onClick={handleSortName}
      />

      <Button
        label={t("sort date")}
        className={classNames(
          {
            [styles.activeButton]: filter.sortType === SORT_TYPE.DATE,
          },
          styles.button,
        )}
        icon={filter.sortDate ? "FiArrowDown" : "FiArrowUp"}
        onClick={handleSortDate}
      />

      <Button
        label={t("sort price")}
        className={classNames(
          {
            [styles.activeButton]: filter.sortType === SORT_TYPE.PRICE,
          },
          styles.button,
        )}
        icon={filter.sortPrice ? "FiArrowDown" : "FiArrowUp"}
        onClick={handleSortPrice}
      />
    </div>
  );
}

export default SearchFilter;
